import { useContext } from 'react';

import { PreflightContext } from './PreflightContext';

export const usePreflightContext = () => {
  const context = useContext(PreflightContext);
  if (!context) {
    throw new Error('usePreflightContext must be used within a PreflightProvider');
  }
  return context;
};
